import { useCallback } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AdminAccessGuard } from '@components/guards/AdminAccessGuard';
import { useLabFieldValues, useDeleteLabFieldValue } from '@api/bff/labField';
import { ActionCommandsHeader, ActionCommandsList } from './components';

export const ActionCommands = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { data: values = [], isLoading } = useLabFieldValues();
  const deleteMutation = useDeleteLabFieldValue();

  const handleDelete = useCallback(
    (value: string) => {
      deleteMutation.mutate(value);
    },
    [deleteMutation]
  );

  return (
    <AdminAccessGuard>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          backgroundColor: theme.palette.background.default
        }}
      >
        <ActionCommandsHeader />

        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            padding: { xs: 2, sm: 3, md: 4 }
          }}
        >
          <Box
            sx={{
              maxWidth: 700,
              margin: '0 auto'
            }}
          >
            <Box sx={{ mb: 3 }}>
              <Typography variant="body1" color="text.secondary">
                {t('settings:administration.tools.actionCommands.description')}
              </Typography>
            </Box>

            <ActionCommandsList
              values={values}
              isLoading={isLoading}
              onDelete={handleDelete}
            />
          </Box>
        </Box>
      </Box>
    </AdminAccessGuard>
  );
};
